import { modalRenderer } from '~/modal/modalRendererRegistry';
import { PrepareDataModalComponent } from './prepareDataModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    PrepareData: undefined;
  }
}

modalRenderer.register('PrepareData', PrepareDataModalComponent);
